import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { connect } from 'react-redux';

import iconWarning from '../images/newinform/ic_warning.svg'
import { updateContactInfo, updateClaimId, updateClaimType, updateContactInfoTemporary } from '../reducers/formActions';
import iconDropDown from '../images/dropdown/ic_dropdown.svg'
import iconDropDownChecked from '../images/dropdown/ic_dropdown_checked.svg'

import { validateEngTextNoSpace, validateText } from '../utils/validate'
import { CONTACT_TYPES, CONTACT_TYPE } from '../utils/contact-type'
import iconCoppy from '../images/summary/ic_coppy.svg'
import ModalAlertError from './ModalAlertError';

import { Combobox, Transition, Listbox } from '@headlessui/react'
import { getTitles } from '../services/fetchTitles';
import { getGarages, NEW_GARAGE, GARAGE_SELECTOR } from '../services/fetchGarages';


const CustomInput = forwardRef((props, ref) => {
  const { garageAddress, widthInput, inputRef, garageName, spamHiddenGarageName, divGarageName, widthGarageAddress } = props
  return (
    <>
      <div 
        ref={divGarageName}
        className={'absolute bg-white overflow-hidden whitespace-nowrap w-full h-[48px] font-prompt text-md border px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
      >
        <input {...props} style={{width:widthInput}} 
          ref={inputRef}
          className={'focus:outline-none focus:border-0  align-middle leading-[46px] '} 
          maxlength="255"
        />
          <span style={{width:widthGarageAddress}} className={'inline-block overflow-auto text-ellipsis whitespace-nowrap align-middle leading-[46px] text-grey-800'} >
            {garageAddress}
          </span>
      </div>
      <span className={'h-[1px] opacity-0'} ref={spamHiddenGarageName}>
        {garageName}
      </span>
    </>
  )
});

function Step1(props) {
  let onSuccess = props.onSuccess
  let onSearchRefNo = props.onSearchRefNo

  const CONTACT_TYPE_OWNER = '1'
  const CONTACT_TYPE_GARAGE = '2';
  const CONTACT_TYPE_OTHER = '9';

  //รถประกัน หรือ คู่กรณี
  const [ suffererType, setSuffererType ] = useState(props.lisence_info.sufferer_type)

  //เลขอ้างอิง
  const [ refNo, setRefNo ] = useState( '' )
  //คำนำหน้า
  const [ customerTitleCode, setCustomerTitleCode ] = useState(  props.contact_info.title_code )
  //ชื่อ นามสกุล
  const [ customerName, setCustomerName ] = useState( props.contact_info.name )
  //รหัส อู่ศูนย์
  const [ garageCode, setGarageCode ] = useState(  props.contact_info.garage_code  )
  //ชื่อ อู่ศูนย์
  const [ garageName, setGarageName ] = useState(  props.contact_info.garage_name  )
  //ไม่มี อู่ศูนย์ ในระบบ
  const [ noGarageInSystem, setNoGarageInSystem ] = useState(  props.contact_info.no_garage_in_system )
  //เบอร์
  const [ customerTel, setCustomerTel ] = useState(  props.contact_info.tel  )
  //Email
  const [ customerEmail, setCustomerEmail ] = useState(  props.contact_info.email  )
  //Line
  const [ customerLine, setCustomerLine ] = useState(  props.contact_info.line_id  )

  //ประเภทผู้มาติดต่อ
  const [ contactType, setContactType ] = useState(  props.contact_info.contact_type  )
  //ผู้รับมอบอำนาจ
  const [ isAttorney, setIsAttorney ] = useState(  props.contact_info.is_attorney  )
  //ติดต่อในนามนิติ
  const [ isCompany, setIsCompany ] = useState(  props.contact_info.is_company  )

  const [contactRefNo, setContactRefNo] = useState(  props.contact_info.ref_no  )

  const [ contactTypeList, setContactTypeList ] = useState(CONTACT_TYPES  )
  const [ isShowDropDown, setIsShowDropDown ] = useState(false)
  
  const [ arrayTitles, setArrayTitles ] = useState([])
  const [ titleCodeList, setTitleCodeList ] = useState([])
  const [ isShowDropDownTitleCode, setIsShowDropDownTitleCode ] = useState(false)
  
  const [ isEnableNewStep, setIsEnableNewStep ] = useState(false  )

  const [ isValidSearchTransaction, setIsValidSearchTransaction] = useState(false  )

  const [ widthInput, setWidthInput ] = useState('')
  const [ widthGarageAddress, setWidthGarageAddress ] = useState('')
  const [ garageAddress, setGarageAddress ] = useState('')
  const [ arrayGarage, setArrayGarage ] = useState([])
  const [ listGarage, setListGarage ] = useState([])
  const [queryGarage, setQueryGarage] = useState('')
  const TEXT_NO_GARAGE = 'ไม่มีในระบบ';

  const spamHiddenGarageName = useRef(null);
  const divGarageName = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      const { listGarages} = await getGarages()

      if(spamHiddenGarageName.current){
        setWidthInput(`${( spamHiddenGarageName.current.offsetWidth == 0 ? 100 : spamHiddenGarageName.current.offsetWidth+10 )}px`)
        const calWidthGarageAddress = divGarageName.current.offsetWidth - spamHiddenGarageName.current.offsetWidth - 42
        setWidthGarageAddress(`${calWidthGarageAddress}px`)
      }
      let textGarageAddress = `(${TEXT_NO_GARAGE})`
      if(!noGarageInSystem){
        let resultTemporary = listGarages.filter((garage) => {
          return garage.id == garageCode
        })
        if(resultTemporary.length > 0){
          const [ resultGarage ] = resultTemporary
          textGarageAddress = resultGarage.address
        }
      }
      if(garageName){
        setGarageAddress(textGarageAddress)
      }
    }
    
    fetchData()

  }, [garageName]);

  
  const filteredListGarage =
  queryGarage.length <= 0
    ? []
    : filterGarageName()

  function filterGarageName(){
    let result = []
    let runWhile = true
    const  lengthGarage = listGarage.length
    const size = 1000
    let end = size
    let start = end - size
    while (runWhile) {
     const sliceListGarage = listGarage.slice(start , end);
      let resultTemporary = sliceListGarage.filter((garage) => {
        return garage.name.toLowerCase().includes(queryGarage.toLowerCase())
      })
      result = [...result, ...resultTemporary]
      if(lengthGarage <= end){
        runWhile = false
      }
      start = end + 1
      end = end + size
    }
    return result.slice(0 , 500)
  }


  const [queryTitleCode, setQueryTitleCode] = useState('')
  const filteredTitleCode =
  queryTitleCode === ''
    ? titleCodeList
    : titleCodeList.filter((item) =>
      item.name
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(queryTitleCode.toLowerCase().replace(/\s+/g, ''))
      )

  useEffect(() => {
    const fetchData = async () => {
      const {arrayTitles, listTitles } = await getTitles()
      setTitleCodeList(listTitles)
      setArrayTitles(arrayTitles)

      const { arrayGarages, listGarages} = await getGarages()
      setListGarage(listGarages)
      setArrayGarage(arrayGarages)
    }
    fetchData()

  },[])
  
  useEffect(() => {
    if (props.contact_info) {
      setSuffererType(props.lisence_info.sufferer_type)
      setCustomerTitleCode( props.contact_info.contact_title_code || null )
      setCustomerName(props.contact_info.name )
      setGarageCode( props.contact_info.garage_code )
      setGarageName( props.contact_info.garage_name )
      setNoGarageInSystem( props.contact_info.no_garage_in_system )
      setCustomerTel( props.contact_info.tel )
      setCustomerEmail( props.contact_info.email )
      setCustomerLine( props.contact_info.line_id )
      setContactType( ( props.contact_info.contact_type > 0 )? props.contact_info.contact_type : null )
      setIsAttorney( props.contact_info.is_attorney )
      setIsCompany( props.contact_info.is_company )
      setContactRefNo( props.contact_info.ref_no )
      setRefNo( props.contact_info.ref_no)
    } 
  }, [ props.contact_info ])

  useEffect(() => {
    if(customerName !== "" && customerTel !== ""
      && customerTel.substring(0, 1) === '0' 
      && (customerTel.length === 10 )
      && contactType !== null
      && customerTitleCode !== null
    ){
      if(contactType == CONTACT_TYPE_GARAGE){
        if(garageName !== ""){
          setIsEnableNewStep(true)
        }
        else{
          setIsEnableNewStep(false)
        }
      }
      else {
        setIsEnableNewStep(true)
      }
      
    }
    else{
      setIsEnableNewStep(false)
    }
  }, [ customerName, garageName, customerTel, contactType, customerTitleCode ])

  useEffect(() => {
    if(
      refNo !== "" && refNo.length === 11 ) {
      setIsValidSearchTransaction(true)
    } else {
      setIsValidSearchTransaction(false)
    }
  }, [refNo])
  



  function onChangeThaiText( event ){
    if ( validateText( event )) {
      return (event.target.value).substring(0, (event.target.value).length-1)
    }
    else if( event.nativeEvent.data === undefined){
      return ""
    }
    else{
      return event.target.value
    }
  }

  function onChangeEmailAndLine( event ){
    if ( validateEngTextNoSpace( event )) {
      return (event.target.value).substring(0, (event.target.value).length-1)
    }
    else if( event.nativeEvent.data === undefined){
      return ""
    }
    else{
      return event.target.value
    }
  }



  function submit(  ){
    setIsShowDropDown(false);

    onSuccess(    
      customerName, contactType, garageCode, garageName,noGarageInSystem,
      isAttorney, isCompany, 
      customerTel, customerEmail, customerLine, refNo, customerTitleCode
    )
  }

  function submitGarage(input,id,name,address){
    
    if(input !== GARAGE_SELECTOR){
      const result = listGarage.filter((garage) => garage.name === name.trim());
      if(result.length > 0){
        const [garage] = result
        id = garage.id
        name = garage.name
      }else{
        id = NEW_GARAGE
        name = name.trim()
      }
    }
    setGarageCode(id)
    setGarageName(name)
    setGarageAddress(address)
    setNoGarageInSystem(id === NEW_GARAGE ? true:false)

    props.updateContactInfoTemporary({
      ...props.contact_info_temporary,
      garageName: name
    })
  }


  const regExTel = ( data ) => {
    if (!/(^[0]{0,1}$)|(^[0]{1}[0-9]{1,9}$)/.test(data) && 
        (data !== null) && 
        (data !== undefined) 
      ) {
      return false
    }
    return true
  }

  const regExRefNo = ( event ) => {
  
      return (!/^([0-9])/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) )
    
  }

  

  const validateTel = (event, setter) =>  {
    isValidateFull(event, setter, regExTel);
  }

 
  const isClear = ( event ) => {
    if ( event.nativeEvent.data === undefined) {
      return true;
    }
    return false;
  }
  const isValidateFull = (event, setter, method) => {
    if (isClear(event)) {
      setter("")
    } else {
      if(!method(event.target.value)){
        event.preventDefault();
      } else {
        //Set Value
        setter(event.target.value)
      }
    }
  }

  function onChangeNumber( event, setterInput ){

    validateTel(event, setterInput)
  }

  function onChangeRefNo( event, setterInput ){
    if (event.target.value.length > 11) {
      return (event.target.value).substring(0, (event.target.value).length-1)
    } else {
    
      if ( regExRefNo( event )) {
        return (event.target.value).substring(0, (event.target.value).length-1)
      }
      else if( event.nativeEvent.data === undefined){
        return ""
      }
      else{
        return event.target.value
      }
    }
  }


  function search() {

    if (refNo) {
      onSearchRefNo(refNo)
    } else {
      setContactRefNo( '' )
    }
  }

  
  function coppyTrackNoToClipboard(){
    navigator.clipboard.writeText(contactRefNo)
  }


  return (
    <div className=' flex-wrap w-full '>
          <div className="flex flex-wrap w-full justify-center p-0  ">

          <div className='flex flex-wrap w-full md:w-[1092px] px-4 md:px-20 md:pb-20 md:pt-[40px] ' >

            <div className=" flex flex-wrap w-full py-6 md:pt-0 md:pb-12  md:px-0 border-b-[0.5px] border-grey-500">
                <div className='flex w-full flex-wrap md:flex-nowrap'>
                  <div className='flex w-full md:w-fit flex-wrap'>
                
                    {
                      contactRefNo ?
                      <div className='flex w-full items-center  flex-wrap'>
                         <span className='w-fit text-lg  md:text-xl font-medium not-italic'>เลขที่รายการ:  <span data-testid='referenceNo-text' >{contactRefNo}</span> </span>

                        <div className='flex-none flex'>
                          <div className='flex'>
                            <img data-testid='copy-referenceNo-button' onClick={ (e) => { coppyTrackNoToClipboard() }} src={iconCoppy} alt="icon-copy" className=' cursor-pointer w-[40px] h-[40px]' />
                          </div>
                          
                        </div>
                      </div>
                      :

                      <div className='flex w-full  flex-wrap'>
                         <span className='w-full text-lg  md:text-xl font-medium not-italic'>เลขที่รายการ: <span data-testid='referenceNo-text' >-</span> </span>
                      </div>
                    }
                    <span className='w-full mt-1 md:mt-2 text-sm font-normal not-italic text-grey-600'>สามารถใช้เลขนี้กรอกในช่อง “เลขที่รายการที่ดำเนินค้างไว้” เพื่อบันทึกข้อมูลที่กำลังรอส่ง</span>
                  </div>

                  <div className='flex w-full items-center justify-end flex-wrap mt-4 md:mt-0'>
                    {/* <div className='w-full flex flex-wrap justify-end'> */}
                      <div className='flex w-[441px] flex-nowrap  md:flex-wrap'>
                        <div className='flex flex-nowrap md:flex-nowrap w-full mt-0'>
                          <div className='w-full grow-0 pr-0 md:pr-[8px]'>
                            <span className='flex-wrap w-full  text-sm font-medium'>เลขที่รายการที่ดำเนินค้างไว้</span>
                            <input 
                              data-testid='referenceNo-input'
                              value={refNo} onChange={ (e)=> {
                                  setRefNo(onChangeRefNo( e ))
                              }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ค้นหา' />
                          </div> 
                          <div className='flex flex-none  items-end flex-wrap w-[78px] md:w-fit justify-end   '>

                            <button
                                data-testid='search-button' 
                                onClick={(() => { search() })}
                                disabled={ (isValidSearchTransaction)? '':'disabled'}
                                className={'w-full md:w-[80px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  '+ ( (isValidSearchTransaction)? ' bg-green-500 text-white ' : ' bg-grey-100 text-white ')}>
                                  ค้นหา
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>  
                  {/* </div> */}
                </div>
            </div>

            <div className=" flex flex-wrap w-full py-6 md:pt-[48px] md:pb-12  md:px-0 border-b-[0.5px] border-grey-500">

                <div className='flex w-full'>
                  <span data-testid='pageTitle-label' className='w-full text-xl  md:text-2xl font-medium not-italic'>ข้อมูลผู้เรียกร้องค่าสินไหม</span>
                </div>

                <div className='flex-wrap w-full mt-6 md:mt-12'>
                  <span className=' text-black flex-wrap w-full text-sm font-medium'>ประเภทรถ<span className='text-red-500'>*</span></span>
                  <div className='flex w-full mt-2'>
                      {
                        (suffererType === 0) ?
                        <div className={' h-[40px] min-w-[97px] w-fit py-2 px-4 rounded-[100px] '+( (suffererType === 0)? ' bg-green-200 ' : ' bg-white  border border-grey-300 ' )}>
                          <span data-testid='suffererType-text' className={' text-base font-normal not-italic '+( (suffererType === 0)? ' text-green-500' : ' text-black' )}>รถประกัน</span>
                        </div>
                        :

                        <div className={' h-[40px] min-w-[97px] w-fit py-2 px-4  rounded-[100px] '+( (suffererType !== 0)? ' bg-green-200 ' : ' bg-white  border border-grey-300 ' )}>
                          <span data-testid='suffererType-text' className={' text-base font-normal not-italic '+( (suffererType !== 0)? ' text-green-500' : ' text-black' )}>รถคู่กรณี</span>
                        </div>
                      }
                
                 
                  </div>
                </div>


                <div className='flex-wrap w-full md:w-1/2 mt-6'>
                  <span className=' text-black flex-wrap w-full text-sm font-medium'>คำนำหน้า<span className='text-red-500'>*</span></span>
                  <div className="flex-wrap w-full">
                    <Combobox value={customerTitleCode} >
                      <div className="relative mt-1">
                        <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left  ">
                          <Combobox.Input
                            className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                            displayValue={() => arrayTitles[customerTitleCode]}
                            onChange={(event) => setQueryTitleCode(event.target.value)}
                          />

                          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            <div className='flex-none my-auto'>
                              <img src={iconDropDown} className='w-[16px] h-[16px] mr-[10px]' alt='icon-dropdown-arrow' />
                            </div>
                          </Combobox.Button>
                        </div>
                        <Transition>
                          <Combobox.Options className="absolute mt-[11px] mx-auto max-h-96 overflow-y-scroll mt-[10px] w-full  bg-white mt-[4px]  rounded-lg shadow-dropdown z-10">
                            {filteredTitleCode.length === 0 && queryTitleCode !== '' ? (
                            <></>
                            ) : (
                              filteredTitleCode.map((item) => (
                                <Combobox.Option
                                  className={'border-b w-full flex cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}
                                  value={item}
                                  onClick={ (e) => { 
                                    setCustomerTitleCode(item.id)
                                  }}
                                >
                                  {({ selected }) => (
                                    <>
                                      <div className='grow w-full'>
                                        <span className={'text-sm leading-5 font-normal'} >
                                          {item.name}
                                        </span>
                                      </div>
                                      <div className='flex-none my-auto'>
                                          {
                                            (item.id === customerTitleCode) ?
                                              <img alt='icon-dropdown-checked' src={iconDropDownChecked} className='w-[20px] h-[20px]' />
                                              :
                                              null
                                          }
                                      </div>
                                    </>
                                  )}
                                </Combobox.Option>
                              ))
                            )}
                          </Combobox.Options>
                        </Transition>
                      </div>
                    </Combobox>
                  </div>
                    {/* Dropdown */}
                    {/* <div className='flex w-full mt-1'>
                      <div className=' flex-wrap w-full'>
                        <div className='w-full  h-[48px]  relative bg-white border-grey-300 border  rounded-lg font-prompt '>
                          <div
                          data-testid='contactType-dropdown' 
                          onClick={ (e) => { setIsShowDropDownTitleCode(!isShowDropDownTitleCode);   }}
                          className=' cursor-pointer w-full py-3.5 px-4 flex'>
                            <div className='grow w-full'>
                              <span className='text-base leading-5 font-normal'>{ arrayTitles[customerTitleCode] }</span>
                            </div>
                            <div className='flex-none my-auto'>
                              <img src={iconDropDown} className='w-[16px] h-[16px]' alt='icon-dropdown-arrow' />
                            </div>
                          </div>
                          <div className={
                            ((isShowDropDownTitleCode)? ' absolute ' : ' hidden ')+
                            'w-full  bg-white mt-[4px]  rounded-lg shadow-dropdown z-10 '}>
                            <div className='w-full flex flex-wrap'>
                              { titleCodeList &&
                                titleCodeList.map(function(item, index){
                                  return (
                                    <div 
                                    onClick={ (e) => { 
                                      setCustomerTitleCode(item.id); 
                                      setIsShowDropDownTitleCode(!isShowDropDownTitleCode);
                                    }}
                                    className={
                                      ((index < titleCodeList.length-1 )? ' border-b ' : '')+
                                      ((index === 0 )? ' rounded-t-lg ' : '')+
                                      ((index == titleCodeList.length-1 )? ' rounded-b-lg ' : '')+
                                      ' w-full flex cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}>
                                      <div className='grow w-full'>
                                        <span className='text-sm leading-5 font-normal' >{item.description}</span>
                                      </div>
                                      <div className='flex-none my-auto'>
                                        {
                                          (item.id == customerTitleCode)?
                                            <img alt='icon-dropdown-checked' src={iconDropDownChecked} className='w-[20px] h-[20px]' />
                                          :
                                            null
                                        }
                                        
                                      </div>
                                    </div>  
                                  )
                                })
                              }
                            </div>
                          
                          </div>
                        </div>
                      </div> 
                    </div> */}
                     {/* Dropdown */}
                </div>

                
                <div className='flex-wrap w-full md:w-1/2 mt-6 pl-0 md:pl-6'>
                  <span className=' text-black flex-wrap w-full text-sm font-medium'>ชื่อ-นามสกุล<span className='text-red-500'>*</span></span>
                  <div className='flex w-full mt-1'>
                    <div className=' flex-wrap w-full'>
                      <input data-testid='name-input' value={customerName} onChange={ (e)=> { setCustomerName(onChangeThaiText(e))  }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
                    </div> 
                  </div>
                </div>


                <div className='flex-wrap w-full md:w-1/2 mt-6'>
                  <span className='text-black flex-wrap w-full text-sm font-medium'>ประเภทผู้มาติดต่อ<span className='text-red-500'>*</span></span>
                  <div className="flex-wrap w-full">
                  <Listbox value={contactType} >
                    <div className="relative mt-1">
                      <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left  ">
                        <Listbox.Button 
                          className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                        >
                          <div className='w-full inline-flex'>
                            <span>{ CONTACT_TYPE(contactType+'') }</span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2" ><img src={iconDropDown} className='w-[16px] h-[16px] mr-[10px]' alt='icon-dropdown-arrow' /></span>
                          </div>
                        </Listbox.Button>
                      </div>
                      <Transition>
                        <Listbox.Options
                          className={'absolute mt-[11px] mx-auto max-h-96 overflow-y-scroll mt-[10px] w-full bg-white mt-[4px]  rounded-lg shadow-dropdown z-50'}
                        >
                          {
                            contactTypeList.map(function(item, index){
                              return (
                                <Listbox.Option key={item.id} value={item.id}
                                  className={'border-b w-full  cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}
                                  onClick={ (e) => { 
                                    setContactType(item.id); 
                                    setIsShowDropDown(!isShowDropDown);
                                    setIsAttorney(false)
                                    setIsCompany(false)
                                    if(item.id != 2) {
                                      setGarageName('')
                                      setGarageAddress('')
                                      setGarageCode(null)
                                      setNoGarageInSystem(false)
                                    }

                                    props.updateContactInfoTemporary({
                                      ...props.contact_info_temporary,
                                      contactTypeName: item.description,
                                      contact_type: item.id
                                    })
                                  }}
                                >
                                  <div className='w-full inline-flex'>
                                  <span>{item.description}</span>
                                  {
                                    (item.id == contactType) ?
                                      <span className="absolute right-0 flex items-center pr-2" >
                                        <img alt='icon-dropdown-checked' src={iconDropDownChecked} className='w-[20px] h-[20px]' />
                                      </span>
                                      :
                                      null
                                  }
                                  </div>
                                </Listbox.Option>
                              )
                            })
                          }
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </Listbox>
                  </div>
                </div>

                {
                  ( contactType == CONTACT_TYPE_GARAGE )?
                    <div className='flex-wrap w-full md:w-1/2 mt-6 pl-0 md:pl-6 h-[52px]'>
                      <span className='flex-wrap w-full text-sm font-medium'>ชื่อศูนย์บริการ/อู่/บริษัทรถยก<span className='text-red-500'>*</span></span>
                      {/* <div className='flex w-full mt-1'>
                        <div className=' flex-wrap w-full'>
                          <input data-testid='garageName-input' value={garageName} onChange={ (e)=> { setGarageName(onChangeThaiText(e))  }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
                        </div> 
                      </div> */}

                      <div className="flex-wrap w-full">
                        <Combobox value={garageName} nullable static >
                        {({ open }) => (
                            <div className="relative mt-1">
                            {/* <div className="relative mt-1"> */}
                                <div >
                                {/* <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left  "> */}
                                  {/* <Combobox.Input
                                    placeholder='ระบุ'
                                    className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                                    displayValue={() => {
                                      return garageName
                                    }} 
                                    onChange={(event) => setQueryGarage(event.target.value)}
                                    onKeyDown={(e)=>{
                                      if(e.key === 'Enter'){
                                        submitGarage('','',e.target.value)
                                      }
                                    }}
                                  /> */}

                                  <Combobox.Input
                                   as={CustomInput}
                                   refName="inputRef"
                                   placeholder='ระบุ'
                                   widthInput ={widthInput}
                                   garageAddress={garageAddress}
                                   garageName={garageName}
                                   spamHiddenGarageName={spamHiddenGarageName}
                                   divGarageName={divGarageName}
                                   widthGarageAddress={widthGarageAddress}
                                   
                                    // className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                                    displayValue={() => {
                                      return garageName
                                    }} 
                                    onChange={(event) => setQueryGarage(event.target.value)}
                                    onKeyDown={(e)=>{
                                      if(e.key === 'Enter'){
                                        submitGarage('','',e.target.value, e.target.value ? `(${TEXT_NO_GARAGE})`:'')
                                      }
                                    }}
                                    onInput={(e)=>{
                                      if(e.target.value === ''){
                                        setGarageAddress('')
                                      }
                                    }}
                                  />
                                  
                                </div>
                                
                                {open && (
                                <Combobox.Options className={"absolute "+(garageName == '' ? 'mt-[60px] ':'mt-[30px] ')+" mx-auto max-h-96 overflow-y-scroll  w-full  bg-white mt-[4px]  rounded-lg shadow-dropdown z-10 " }>
                                  { (queryGarage.length > 0 && filteredListGarage.length === 0 ) && (
                                    // new garage
                                    <Combobox.Option static 
                                      value={{ id: null, name: queryGarage }}
                                      className={'border-b w-full flex cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}
                                      onClick={ (e) => { 
                                        submitGarage(GARAGE_SELECTOR,NEW_GARAGE,queryGarage,`(${TEXT_NO_GARAGE})`)
                                      }}
                                    >
                                      <span className={'text-sm leading-5 font-normal'} >
                                        {queryGarage}
                                      </span>
                                    </Combobox.Option>
                                  )}
                                  {
                                    filteredListGarage.map((garage,index) => (
                                      <Combobox.Option  static
                                        key={garage.id}
                                        className={'border-b w-full flex flex-col cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}
                                        value={garage}
                                        onClick={ () => { 
                                          submitGarage(GARAGE_SELECTOR,garage.id,garage.name,garage.address)
                                        }}
                                      >
                                        {() => (
                                          <>
                                            <span className={'text-sm leading-5 font-normal'} >
                                              {garage.name}
                                            <br/>
                                            <span className={'text-sm leading-5 font-normal  text-grey-800'} >
                                              {garage.address}
                                            </span>
                                            </span>
                                          </>
                                        )}
                                      </Combobox.Option>
                                    ))
                                  }
                                </Combobox.Options>
                                )}
                            </div>
                        )}
                        </Combobox>
                      </div>

                    </div>
                    :
                    null

                }

                {
                  ( contactType == CONTACT_TYPE_OWNER || contactType == CONTACT_TYPE_GARAGE  || contactType == CONTACT_TYPE_OTHER)?
                    <div className='flex-wrap w-full mt-8 '>
                      <label class="container" style={{width:'160px'}}>
                        <input
                        data-testid='assignee-checkbox' 
                        checked={(isAttorney)? 'checked' : ''}
                        onChange={ (e)=> { setIsAttorney(!isAttorney) }} 
                        type={'checkbox'} 
                        className={'text-md  w-[16px] h-[16px] my-auto accent-green-500 '} />
                        <span class="checkmark"></span>
                        <span className=' font-normal not-italic my-auto ml-4 text-base leading-5'>เป็นผู้รับมอบอำนาจ</span>
                      </label>  
                    </div>
                    :
                    null
                }

                {
                  ( contactType == CONTACT_TYPE_OWNER )?
                    <div className='flex-wrap w-full md:w-fit flex'>
                      <div className='flex-wrap w-full md:w-fit mt-6'>
                        <label class="container">
                          <input
                          data-testid='legalEntity-checkbox' 
                          checked={(isCompany)? 'checked' : ''}
                          onChange={ (e)=> { setIsCompany(!isCompany) }} 
                          type={'checkbox'} 
                          className='text-md  w-6 h-6 my-auto accent-green-500' />
                          <span class="checkmark"></span>
                          <span className=' my-auto ml-4 text-base leading-5'>ติดต่อในนามนิติบุคคล</span>
                        </label>
                      </div>
                        
                      <div className='flex  w-full md:w-fit mt-6 md:pl-6'>
                        <div className='flex-none'>
                          <img src={iconWarning} alt="icon-warning" className='w-[16px] h-[16px] my-auto' />
                        </div>

                        <div className={ 'grow flex w-full pl-[9px] '}>
                          <span className='w-full text-base leading-5 text-orange-500'>หากคุณเป็นองค์กรหรือบริษัทที่มีการจดทะเบียนกรุณาระบุ</span>   
                        </div>
                        

                      </div>
                    </div>
                  :
                  null
                }

            </div>


            <div className="flex flex-wrap w-full  py-6 md:py-12  px-0  md:px-0 ">

                <div className='flex flex-wrap  w-full'>
                  <span data-testid='pageTitle-label' className='w-full text-xl md:text-2xl font-medium'>ช่องทางที่ให้ติดต่อกลับ</span>
                  <span className='w-full mt-1 md:mt-2 text-sm font-normal not-italic text-grey-600'>ทางไทยวิวัฒน์จะแจ้งผลการดำเนินการข้อมูลสถานะต่างๆ ตามข้อมูลติดต่อที่ระบุ กรุณาตรวจสอบความถูกต้องก่อนการทำรายการ</span>
                </div>


                <div className='flex-wrap w-full md:w-1/2'>
                  <div className='flex-wrap w-full  mt-6 md:mt-12'>
                    <span className='flex-wrap w-full text-sm font-medium'>เบอร์โทรศัพท์ (สำหรับแจ้งผลค่าสินไหมผ่าน SMS)<span className='text-red-500'>*</span></span>
                    <div className='flex w-full mt-1'>
                      <div className=' flex-wrap w-full'>
                        <input 
                          data-testid='contactNo-input'
                          value={customerTel} onChange={ (e)=> {  
                            onChangeNumber( e, setCustomerTel )  
                            
                            }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='000 000 0000' />
                      </div> 
                    </div>
                    <span className='flex-wrap w-full mt-1 text-xs text-grey-600  font-normal not-italic  '>*กรุณาระบุหมายเลขโทรศัพท์ที่ต้องการใช้รับแจ้งผลการเรียกร้องสินไหม</span>
                  </div>
                </div>


                <div className='flex flex-wrap w-full'>
                  <div className='flex-wrap w-full md:w-1/2 mt-6'>
                    <span className='flex-wrap w-full text-sm font-medium'>อีเมล <span className='text-grey-800 font-normal not-italic '>(ถ้ามี)</span></span>
                    <div className='flex w-full mt-1'>
                      <div className=' flex-wrap w-full'>
                        <input data-testid='contactEmail-input' value={customerEmail} onChange={ (e)=> { setCustomerEmail(onChangeEmailAndLine(e))  }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  />
                      </div> 
                    </div>
                  </div>


                  <div className='flex-wrap w-full md:w-1/2 mt-6 mb-14 md:pl-6'>
                    <span className='flex-wrap w-full text-sm font-medium'>Line ID <span className='text-grey-800 font-normal not-italic '>(ถ้ามี)</span></span>
                    <div className='flex w-full mt-1'>
                      <div className=' flex-wrap w-full'>
                        <input data-testid='contactLineID-input' value={customerLine} onChange={ (e)=> {  setCustomerLine(onChangeEmailAndLine(e)) }} type={'search'} className={'w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  />
                      </div> 
                    </div>
                  </div>
                </div>
                

            </div>

            <div className='flex-wrap flex w-full mt-6 md:mt-20  md:h-80px md:justify-center  bg-white border-t-[0.5px] border-grey-500 fixed bottom-0 right-0'>
              <div className='flex flex-wrap w-full md:w-[1092px] md:justify-end '>

                <button 
                    data-testid='next-button'
                    onClick={submit}
                    disabled={ (isEnableNewStep)? '':'disabled'}
                    className={'w-full m-[16px] md:w-[160px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  '+ ( (isEnableNewStep)? ' bg-green-500 text-white ' : ' bg-grey-100 text-white ')}>
                      ต่อไป
                </button>
              </div>
            </div>

          </div>

          </div>
    </div>
  )
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    updateClaimId : (payload) =>  dispatch(updateClaimId(payload)),
    updateClaimType : (payload) =>  dispatch(updateClaimType(payload)),
    updateContactInfo : (payload) =>  dispatch(updateContactInfo(payload)),
    updateContactInfoTemporary : (payload) =>  dispatch(updateContactInfoTemporary(payload))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step1);